import React, { useEffect, useRef } from "react";

// Since @shopify/Polaris data tables don't allow setting or changing the colspan property
// of a table cell, use this class to modify the cell directly
// It's a hack that can be removed once we use a different component to render tables
const TableCellChild: React.FC<React.HTMLProps<HTMLTableHeaderCellElement>> = ({ children, className, ...props }) => {
  const cellRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (cellRef.current) {
      const tableCell = cellRef.current.parentElement;

      if (tableCell) {
        // @ts-ignore
        Object.keys(props).forEach((name) => tableCell?.setAttribute(name, String(props[name])));
      }

      return () => {
        for (const name in props) {
          tableCell?.setAttribute(name, "");
        }
      };
    }
  }, [cellRef.current]);

  return (
    <div ref={cellRef} className={className}>
      {children}
    </div>
  );
};

export default TableCellChild;
